/**
 * Creates the controls in the given container.
 * Currently it is possible to create either controls for all parameters or for specified settings.
 *
 * @param {Object} api The api that is needed
 * @param {Object} container The container dom in which to put the controls
 * @param {Object} [options] Options that can be given, setting options.settings to true makes this a controls element for the settings
 * @param {Object} [options.settings] If true, these are the controls for the settings
 * @param {Object} [options.editMode] If true, and this is not a settings object, the controls are made in edit mode
 * @param {Function} [options.showMessage] If defined, use this callback for displaying messages to the user
 */
let SDControls = function (api, container, options) {


  /**
   *
   *
   * VARIABLE DECLARATION
   *
   *
   */
  const API = api,
        CONTAINER = container,
        PARENT = container.parentNode,
        STRING_SDCP = 'sd-control-panel-',
        STRING_SDVCP = 'sdv-control-panel-',
        STRING_SDVCPC = 'sdv-control-panel-control',
        TO_TINY_COLOR = require('../../shared/util/toTinyColor'),
        GLOBAL_UTILS = require('../../shared/util/GlobalUtils'),
        SHOW_MESSAGE = options && options.showMessage ? options.showMessage : () => {},
        EPS = .000001,
        TYPES = {
          SLIDER: 'slider',
          STRING: 'string',
          BOOLEAN: 'boolean',
          COLOR: 'color',
          BUTTON: 'button',
          DROPDOWN: 'dropdown',
          CHECKLIST: 'form',
          FILE: 'file',
          //TIME: 'time',
          //DATE: 'date'
        },
        TYPE_CONVERSION = {
          'parameter.Int': 'slider',
          'parameter.Odd': 'slider',
          'parameter.Even': 'slider',
          'parameter.Float': 'slider',
          'parameter.String': 'string',
          'parameter.Bool': 'boolean',
          'parameter.Color': 'color',
          'parameter.StringList.checklist': 'form',
          'parameter.StringList.sequence': 'dropdown',
          'parameter.StringList.cycle': 'dropdown',
          'parameter.StringList.dropdown': 'dropdown',
          'parameter.File': 'file',
          'export': 'button',
          //'parameter.Time.clock': 'time',
          //'parameter.Time.calendar': 'date'
        },
        /**
         * The list of settings, this will be removed as soon as real setting are being provided.
         */
        SETTINGS_LIST = {

          // shadow
          'render.shadows': {
            defval: api.getSetting('render.shadows'),
            id: 0,
            setting: 'render.shadows',
            name: 'Shadows',
            type: TYPES.BOOLEAN
          },
          // AO
          'render.ambientOcclusion': {
            defval: api.getSetting('render.ambientOcclusion'),
            id: 1,
            setting: 'render.ambientOcclusion',
            name: 'Ambient Occlusion',
            type: TYPES.BOOLEAN
          },
          // ambient light intensity 2
          'lights.light1': {
            defval: api.getSetting('lights.light1').properties.intensity,
            id: 2,
            max: 1 + EPS,
            setting: 'lights.light1',
            name: 'Ambient Light Intensity',
            type: TYPES.SLIDER,
            decimalplaces: 3,
            valueConversion: {
              update: 'value',
              f: function (menuEl, obj) {
                let temp = api.getSetting('lights.light1');
                temp.properties.intensity = parseFloat(obj.value);
                return temp;
              },
              i: function (menuEl, obj) {
                return obj.properties.intensity;
              }
            }
          },
          // spotlight intensity 3
          'lights.light2': {
            defval: api.getSetting('lights.light2').properties.intensity,
            id: 3,
            max: 1 + EPS,
            setting: 'lights.light2',
            name: 'Spot Light Intensity',
            type: TYPES.SLIDER,
            decimalplaces: 3,
            valueConversion: {
              update: 'value',
              f: function (menuEl, obj) {
                let temp = api.getSetting('lights.light2');
                temp.properties.intensity = parseFloat(obj.value);
                return temp;
              },
              i: function (menuEl, obj) {
                return obj.properties.intensity;
              }
            }
          },
          // bump amplitude 4
          'bumpAmplitude': {
            defval: api.getSetting('defaultMaterial.bumpAmplitude'),
            id: 4,
            max: 1 + EPS,
            setting: 'defaultMaterial.bumpAmplitude',
            name: 'Bump Amplitude',
            type: TYPES.SLIDER,
            decimalplaces: 3,
          },
          // default material color 5
          'defaultMaterialColor': {
            defval: api.getSetting('defaultMaterial.color'),
            id: 5,
            setting: 'defaultMaterial.color',
            name: 'Default Material Color',
            type: TYPES.COLOR,
            valueConversion: {
              update: 'value',
              f: function (menuEl, obj) {
                let color = TO_TINY_COLOR(obj.value);
                if (menuEl.cInputColor.type === 'color') {
                  return color.toHexString();
                } else {
                  /* eslint-disable */
                  $('#' + menuEl.slugId + '-color').spectrum({
                    color: color.toRgbString(),
                    showInput: true,
                    showInitial: true,
                    preferredFormat: 'rgb'
                  });
                  /* eslint-enable */
                  return color.toRgbString();
                }
              }
            }
          },
          // ground plane toggle
          'groundPlane': {
            defval: api.getSetting('groundPlaneVisibility'),
            id: 6,
            setting: 'groundPlaneVisibility',
            name: 'Ground Plane',
            type: TYPES.BOOLEAN
          },
          // grid toggle
          'grid': {
            defval: api.getSetting('gridVisibility'),
            id: 7,
            setting: 'gridVisibility',
            name: 'Grid',
            type: TYPES.BOOLEAN
          },
          // background color
          'render.clearColor': {
            defval: api.getSetting('render.clearColor'),
            id: 8,
            setting: 'render.clearColor',
            name: 'Background Color',
            type: TYPES.COLOR,
            valueConversion: {
              update: 'value',
              f: function (menuEl, obj) {
                let color = TO_TINY_COLOR(obj.value);
                if (menuEl.cInputColor.type === 'color') {
                  return color.toHexString();
                } else {
                  /* eslint-disable */
                  $('#' + menuEl.slugId + '-color').spectrum({
                    color: color.toRgbString(),
                    showInput: true,
                    showInitial: true,
                    preferredFormat: 'rgb'
                  });
                  /* eslint-enable */
                  return color.toRgbString();
                }
              }
            }
          },
          // background alpha
          'render.clearAlpha': {
            defval: api.getSetting('render.clearAlpha'),
            id: 9,
            setting: 'render.clearAlpha',
            name: 'Background Alpha',
            type: TYPES.SLIDER,
            min: 0.0,
            max: 1,
            decimalplaces: 2,
            valueConversion: function (menuEl, obj) { return parseFloat(obj.value); }
          },
          // env toggle
          'material.environmentMapAsBackground': {
            defval: api.getSetting('material.environmentMapAsBackground'),
            id: 10,
            setting: 'material.environmentMapAsBackground',
            name: 'Environment',
            type: TYPES.BOOLEAN
          },
          // env dropdown
          'material.environmentMap1': {
            defval: api.getSetting('material.environmentMap'),
            choices: ['default', 'default_bw', 'blurred_lights', 'georgentor', 'georgentor_blur', 'georgentor_blue_blur', 'georgentor_bw_blur',
              'mountains', 'ocean', 'piazza_san_marco', 'room_abstract_1', 'sky', 'storage_room', 'storm', 'subway_entrance', 'subway_entrance_bw_blur', 'white', 'yokohama'],
            id: 11,
            setting: 'material.environmentMap',
            name: 'Choose Environment',
            type: TYPES.DROPDOWN,
            valueConversion: { update: 'selectedIndex', f: function (menuEl, obj) { return obj.options[obj.selectedIndex].innerHTML; } }
          },
          // env input text
          'material.environmentMap2': {
            defval: api.getSetting('material.environmentMap'),
            max: 500,
            id: 12,
            setting: 'material.environmentMap',
            name: 'Custom Environment',
            type: TYPES.STRING
          },
          // point size 12
          'pointSize': {
            defval: api.getSetting('render.pointSize'),
            id: 13,
            setting: 'render.pointSize',
            name: 'Point Size',
            type: TYPES.SLIDER,
            min: 0.001,
            max: 100 + EPS,
            decimalplaces: 3,
          },
          // top view 13
          'topView': {
            defval: api.getSetting('camera.type'),
            id: 14,
            setting: 'camera.type',
            name: 'Top View',
            type: TYPES.BOOLEAN,
            valueConversion: {
              update: 'value',
              f: function (menuEl, obj) {
                return obj.checked ? 1 : 0;
              },
              i: function (menuEl, obj) {
                return obj === 1 ? true : false;
              }
            }
          },


          // disable zoom 14
          'enableZoom': {
            defval: !api.getSetting('camera.enableZoom'),
            id: 15,
            setting: 'camera.enableZoom',
            name: 'Disable Zoom',
            type: TYPES.BOOLEAN,
            valueConversion: {
              update: 'value',
              f: function (menuEl, obj) {
                return !obj.checked;
              },
              i: function (menuEl, obj) {
                return !obj;
              }
            }
          },
          // zoom speed 15
          'camera.zoomSpeed': {
            defval: api.getSetting('camera.zoomSpeed'),
            id: 16,
            setting: 'camera.zoomSpeed',
            name: 'Zoom Speed',
            type: TYPES.SLIDER,
            min: 0.0,
            max: 1 + EPS,
            decimalplaces: 2,
            valueConversion: function (menuEl, obj) { return parseFloat(obj.value); }
          },
          // disable pan 16
          'enablePan': {
            defval: !api.getSetting('camera.enablePan'),
            id: 17,
            setting: 'camera.enablePan',
            name: 'Disable Pan',
            type: TYPES.BOOLEAN,
            valueConversion: {
              update: 'value',
              f: function (menuEl, obj) {
                return !obj.checked;
              },
              i: function (menuEl, obj) {
                return !obj;
              }
            }
          },
          // rotation speed 17
          'camera.panSpeed': {
            defval: api.getSetting('camera.panSpeed'),
            id: 18,
            setting: 'camera.panSpeed',
            name: 'Pan Speed',
            type: TYPES.SLIDER,
            min: 0.0,
            max: 1 + EPS,
            decimalplaces: 2,
            valueConversion: function (menuEl, obj) { return parseFloat(obj.value); }
          },


          // disable pan 18
          'enableRotation': {
            defval: !api.getSetting('camera.enableRotation'),
            id: 19,
            setting: 'camera.enableRotation',
            name: 'Disable Rotation',
            type: TYPES.BOOLEAN,
            valueConversion: {
              update: 'value',
              f: function (menuEl, obj) {
                return !obj.checked;
              },
              i: function (menuEl, obj) {
                return !obj;
              }
            }
          },
          // rotation speed 19
          'camera.rotationSpeed': {
            defval: api.getSetting('camera.rotationSpeed'),
            id: 20,
            setting: 'camera.rotationSpeed',
            name: 'Rotation Speed',
            type: TYPES.SLIDER,
            min: 0.0,
            max: 1 + EPS,
            decimalplaces: 2,
            valueConversion: function (menuEl, obj) { return parseFloat(obj.value); }
          },

          // auto rotation speed (bool included) 20
          'camera.autoRotationSpeed': {
            defval: api.getSetting('camera.autoRotationSpeed'),
            id: 21,
            setting: 'camera.autoRotationSpeed',
            name: 'Auto Rotation',
            type: TYPES.SLIDER,
            min: -10,
            max: 10 + EPS,
            decimalplaces: 2,
            valueConversion: function (menuEl, obj) { return parseFloat(obj.value); }
          },

          // auto rotation speed (bool included) 21
          'camera.damping': {
            defval: api.getSetting('camera.damping'),
            id: 22,
            setting: 'camera.damping',
            name: 'Damping Factor',
            type: TYPES.SLIDER,
            min: 0.0,
            max: 10 + EPS,
            decimalplaces: 2,
            valueConversion: function (menuEl, obj) { return parseFloat(obj.value); }
          },

          // fov 22
          'camera.fov': {
            defval: api.getSetting('camera.fov'),
            id: 23,
            setting: 'camera.fov',
            name: 'Field of View',
            type: TYPES.SLIDER,
            min: 30,
            max: 90,
            decimalplaces: 3,
            valueConversion: function (menuEl, obj) { return parseFloat(obj.value); }
          },
          // zoom factor 23
          'camera.zoomExtentsFactor': {
            defval: api.getSetting('camera.zoomExtentsFactor'),
            id: 23,
            setting: 'camera.zoomExtentsFactor',
            name: 'Zoom Factor',
            type: TYPES.SLIDER,
            min: 0.01,
            max: 10 + EPS,
            decimalplaces: 2,
            valueConversion: function (menuEl, obj) { return parseFloat(obj.value); }
          },
        };


  let _paramIds = [],
      _menuElements = [],
      _plugins = [],
      _isMobile = false,
      _runtimeId,
      _container, _acc;

  /**
   *
   *
   * VARIOUS DECLARATIONS
   *
   *
   */

  /**
   * IIFE to determine if the current device is a mobile device.
   * This is needed to separate between different options in the menu.
   */
  /* eslint-disable */
  (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) _isMobile = true; })(navigator.userAgent || navigator.vendor || window.opera);
  /* eslint-enable */

  /**
   * Slugification (:D) of a given value.
   * @returns {String} The slugified string
   */
  let _slugify = function () {
    /* eslint-disable */
    let charMap = JSON.parse('{"$":"dollar","&":"and","<":"less",">":"greater","|":"or","¢":"cent","£":"pound","¤":"currency","¥":"yen","©":"(c)","ª":"a","®":"(r)","º":"o","À":"A","Á":"A","Â":"A","Ã":"A","Ä":"A","Å":"A","Æ":"AE","Ç":"C","È":"E","É":"E","Ê":"E","Ë":"E","Ì":"I","Í":"I","Î":"I","Ï":"I","Ð":"D","Ñ":"N","Ò":"O","Ó":"O","Ô":"O","Õ":"O","Ö":"O","Ø":"O","Ù":"U","Ú":"U","Û":"U","Ü":"U","Ý":"Y","Þ":"TH","ß":"ss","à":"a","á":"a","â":"a","ã":"a","ä":"a","å":"a","æ":"ae","ç":"c","è":"e","é":"e","ê":"e","ë":"e","ì":"i","í":"i","î":"i","ï":"i","ð":"d","ñ":"n","ò":"o","ó":"o","ô":"o","õ":"o","ö":"o","ø":"o","ù":"u","ú":"u","û":"u","ü":"u","ý":"y","þ":"th","ÿ":"y","Ā":"A","ā":"a","Ă":"A","ă":"a","Ą":"A","ą":"a","Ć":"C","ć":"c","Č":"C","č":"c","Ď":"D","ď":"d","Đ":"DJ","đ":"dj","Ē":"E","ē":"e","Ė":"E","ė":"e","Ę":"e","ę":"e","Ě":"E","ě":"e","Ğ":"G","ğ":"g","Ģ":"G","ģ":"g","Ĩ":"I","ĩ":"i","Ī":"i","ī":"i","Į":"I","į":"i","İ":"I","ı":"i","Ķ":"k","ķ":"k","Ļ":"L","ļ":"l","Ł":"L","ł":"l","Ń":"N","ń":"n","Ņ":"N","ņ":"n","Ň":"N","ň":"n","Ő":"O","ő":"o","Œ":"OE","œ":"oe","Ř":"R","ř":"r","Ś":"S","ś":"s","Ş":"S","ş":"s","Š":"S","š":"s","Ţ":"T","ţ":"t","Ť":"T","ť":"t","Ũ":"U","ũ":"u","Ū":"u","ū":"u","Ů":"U","ů":"u","Ű":"U","ű":"u","Ų":"U","ų":"u","Ź":"Z","ź":"z","Ż":"Z","ż":"z","Ž":"Z","ž":"z","ƒ":"f","Ơ":"O","ơ":"o","Ư":"U","ư":"u","ǈ":"LJ","ǉ":"lj","ǋ":"NJ","ǌ":"nj","Ș":"S","ș":"s","Ț":"T","ț":"t","˚":"o","Ά":"A","Έ":"E","Ή":"H","Ί":"I","Ό":"O","Ύ":"Y","Ώ":"W","ΐ":"i","Α":"A","Β":"B","Γ":"G","Δ":"D","Ε":"E","Ζ":"Z","Η":"H","Θ":"8","Ι":"I","Κ":"K","Λ":"L","Μ":"M","Ν":"N","Ξ":"3","Ο":"O","Π":"P","Ρ":"R","Σ":"S","Τ":"T","Υ":"Y","Φ":"F","Χ":"X","Ψ":"PS","Ω":"W","Ϊ":"I","Ϋ":"Y","ά":"a","έ":"e","ή":"h","ί":"i","ΰ":"y","α":"a","β":"b","γ":"g","δ":"d","ε":"e","ζ":"z","η":"h","θ":"8","ι":"i","κ":"k","λ":"l","μ":"m","ν":"n","ξ":"3","ο":"o","π":"p","ρ":"r","ς":"s","σ":"s","τ":"t","υ":"y","φ":"f","χ":"x","ψ":"ps","ω":"w","ϊ":"i","ϋ":"y","ό":"o","ύ":"y","ώ":"w","Ё":"Yo","Ђ":"DJ","Є":"Ye","І":"I","Ї":"Yi","Ј":"J","Љ":"LJ","Њ":"NJ","Ћ":"C","Џ":"DZ","А":"A","Б":"B","В":"V","Г":"G","Д":"D","Е":"E","Ж":"Zh","З":"Z","И":"I","Й":"J","К":"K","Л":"L","М":"M","Н":"N","О":"O","П":"P","Р":"R","С":"S","Т":"T","У":"U","Ф":"F","Х":"H","Ц":"C","Ч":"Ch","Ш":"Sh","Щ":"Sh","Ъ":"U","Ы":"Y","Ь":"","Э":"E","Ю":"Yu","Я":"Ya","а":"a","б":"b","в":"v","г":"g","д":"d","е":"e","ж":"zh","з":"z","и":"i","й":"j","к":"k","л":"l","м":"m","н":"n","о":"o","п":"p","р":"r","с":"s","т":"t","у":"u","ф":"f","х":"h","ц":"c","ч":"ch","ш":"sh","щ":"sh","ъ":"u","ы":"y","ь":"","э":"e","ю":"yu","я":"ya","ё":"yo","ђ":"dj","є":"ye","і":"i","ї":"yi","ј":"j","љ":"lj","њ":"nj","ћ":"c","џ":"dz","Ґ":"G","ґ":"g","฿":"baht","ა":"a","ბ":"b","გ":"g","დ":"d","ე":"e","ვ":"v","ზ":"z","თ":"t","ი":"i","კ":"k","ლ":"l","მ":"m","ნ":"n","ო":"o","პ":"p","ჟ":"zh","რ":"r","ს":"s","ტ":"t","უ":"u","ფ":"f","ქ":"k","ღ":"gh","ყ":"q","შ":"sh","ჩ":"ch","ც":"ts","ძ":"dz","წ":"ts","ჭ":"ch","ხ":"kh","ჯ":"j","ჰ":"h","ẞ":"SS","Ạ":"A","ạ":"a","Ả":"A","ả":"a","Ấ":"A","ấ":"a","Ầ":"A","ầ":"a","Ẩ":"A","ẩ":"a","Ẫ":"A","ẫ":"a","Ậ":"A","ậ":"a","Ắ":"A","ắ":"a","Ằ":"A","ằ":"a","Ẳ":"A","ẳ":"a","Ẵ":"A","ẵ":"a","Ặ":"A","ặ":"a","Ẹ":"E","ẹ":"e","Ẻ":"E","ẻ":"e","Ẽ":"E","ẽ":"e","Ế":"E","ế":"e","Ề":"E","ề":"e","Ể":"E","ể":"e","Ễ":"E","ễ":"e","Ệ":"E","ệ":"e","Ỉ":"I","ỉ":"i","Ị":"I","ị":"i","Ọ":"O","ọ":"o","Ỏ":"O","ỏ":"o","Ố":"O","ố":"o","Ồ":"O","ồ":"o","Ổ":"O","ổ":"o","Ỗ":"O","ỗ":"o","Ộ":"O","ộ":"o","Ớ":"O","ớ":"o","Ờ":"O","ờ":"o","Ở":"O","ở":"o","Ỡ":"O","ỡ":"o","Ợ":"O","ợ":"o","Ụ":"U","ụ":"u","Ủ":"U","ủ":"u","Ứ":"U","ứ":"u","Ừ":"U","ừ":"u","Ử":"U","ử":"u","Ữ":"U","ữ":"u","Ự":"U","ự":"u","Ỳ":"Y","ỳ":"y","Ỵ":"Y","ỵ":"y","Ỷ":"Y","ỷ":"y","Ỹ":"Y","ỹ":"y","‘":"\'","’":"\'","“":"\\\"","”":"\\\"","†":"+","•":"*","…":"...","₠":"ecu","₢":"cruzeiro","₣":"french franc","₤":"lira","₥":"mill","₦":"naira","₧":"peseta","₨":"rupee","₩":"won","₪":"new shequel","₫":"dong","€":"euro","₭":"kip","₮":"tugrik","₯":"drachma","₰":"penny","₱":"peso","₲":"guarani","₳":"austral","₴":"hryvnia","₵":"cedi","₹":"indian rupee","₽":"russian ruble","℠":"sm","™":"tm","∂":"d","∆":"delta","∑":"sum","∞":"infinity","♥":"love","元":"yuan","円":"yen","﷼":"rial"}')
    /* eslint-enable */

    function replace(string, options) {
      if (typeof string !== 'string')
        string = string + '';

      options = (typeof options === 'string')
        ? { replacement: options }
        : options || {};

      let slug = string.split('')
        .reduce(function (result, ch) {
          return result + (charMap[ch] || ch)
            // allowed
            .replace(options.remove || /[^\w\s$*_+~.()''!\-:@]/g, '');
        }, '')
        // trim leading/trailing spaces
        .replace(/^\s+|\s+$/g, '')
        // convert spaces
        .replace(/[-\s]+/g, options.replacement || '-')
        // remove trailing separator
        .replace('#{replacement}$', '');

      return options.lower ? slug.toLowerCase() : slug;
    }

    replace.extend = function (customMap) {
      for (let key in customMap) {
        charMap[key] = customMap[key];
      }
    };

    return replace;
  }();


  /**
   *
   *
   * GENERAL MENU ELEMENT CONSTRUCTION
   *
   *
   */

  /**
   * Creates a dom element with the given name as a tag.
   *
   * The properties object can entail the following:
   *  - every property that is directly set
   *  - a property 'classlist' that:
   *    - defines an array of classes that are added to the element or
   *    - defines a string with a single class in it
   *  - a property 'parent' that is used to append the created object to the parent
   *  - a property 'attributes' that defines an object where the key is the name of the attribute and the value the value that it should be set to:
   *    example: attributes: { value: 'test' } triggers element.setAttribute('value', 'test');
   *
   * The class 'shapediver-viewer-element' is added to all elements.
   *
   * @param {String} name The specified name that will be used as the tag for the element
   * @param {Object} properties An object of properties as specified above
   * @returns {Object} The created dom element
   */
  function _createDOMElement(name, properties) {
    let el = document.createElement(name),
        key, attributeKey, p, i, len;

    if (el != null)
      el.classList.add('shapediver-viewer-element');

    for (key in properties) {
      p = properties[key];

      if (key === 'classList') {
        if (Array.isArray(p)) {
          for (i = 0, len = p.length; i < len; i++)
            el.classList.add(p[i]);
        } else {
          el.classList.add(p);
        }
      } else if (key === 'parent') {
        p.appendChild(el);
      } else if (key === 'attributes') {
        for (attributeKey in p)
          el.setAttribute(attributeKey, p[attributeKey]);
      } else {
        if(p !== undefined && p !== null) el[key] = p;
      }
    }

    return el;
  }

  /**
   * Creates a row and does additional shared initialization tasks.
   * The slugified id is created here, too.
   *
   * @param {TYPES} type The type of menu element that is created.
   * @param {String} id The id of the element, must not be used by any other elemnt
   * @param {String} name The name that will be displayed
   * @param {String} [note] An optional note that is used as the tooltip
   * @returns {Array} An array consisting of the slugID, the row and the label
   */
  function _createRow(type, param) {
    let slugId = _runtimeId + '_' + _slugify(param.id),
        row, label;

    row = _createDOMElement('div', { id: slugId + '-controlmenu-row', name: slugId + '-controlmenu-row', parent: _container, /*title: param.note,*/
                                     classList: [STRING_SDVCP + 'row', 'sdv-param-row', 'sd-row-control-type-' + type] });

    label = _createDOMElement('label', { id: slugId + '-label', parent: row, innerHTML: param.name, /*title: param.note,*/
                                         classList: [STRING_SDVCP + 'row-label', STRING_SDVCP + 'parameter-label', STRING_SDVCP + type + '-input-label'],
                                         attributes: { 'for': slugId + '-' + type === 'slider' ? 'range' : type, 'param-id': param.id } });
    if(options && options.editMode) label.classList.add('sdv-edit-mode');

    return [slugId, row, label];
  }


  /**
   *
   *
   * MENU ELEMENT CONSTRUCTION
   *
   *
   */

  /**
   * Function constructor for a menu element.
   * Create a row, creates the content of the row and assigns an update function.
   *
   * @param {TYPES} type The type of menu element that is created.
   * @param {Object} param The parameters that should be used for this menu element.
   *  They can vary widely for different element but must contain an id and name.
   *  The specific values needed can be seen in the createElement functions.
   * @returns {Object} a reference to itself
   */
  function MenuElement(type, param) {
    let that = this;

    that.id = param.id;
    that.plugin = param.plugin;
    that.hidden = param.hidden || false;
    that.order = param.order;
    that.type = type;
    that.name = param.name;
    that.setting = (options && options.settings) ? param.setting : null;

    // add the plugin if it was not in the list
    if (_plugins.indexOf(param.plugin) === -1) _plugins.push(param.plugin);

    // create the row
    [that.slugId, that.row, that.label] = _createRow(type, param);
    // create the specific menu element
    that.createElement[type](that, (options && options.settings) ? param.setting : param.id, param);
    // assign the update function
    that.update = that.updateElement[type];

    return that;
  }

  /**
   * A collection of the creation functions, with the keys being the names of the types. (Used for the assignment)
   */
  MenuElement.prototype.createElement = {
    slider: _createSlider,
    string: _createStringInput,
    boolean: _createBooleanInput,
    color: _createColorInput,
    button: _createButton,
    dropdown: _createDropdownMenu,
    form: _createCheckListMenu,
    file: _createFile,
    //date: _createCalenderMenu,
    //time: _createClockMenu
  };

  /**
   * A collection of the update functions, with the keys being the names of the types. (Used for the assignment)
   */
  MenuElement.prototype.updateElement = {
    slider: _updateSlider,
    string: _updateStringInput,
    boolean: _updateBooleanInput,
    color: _updateColorInput,
    button: _updateButton,
    dropdown: _updateDropdownMenu,
    form: _updateCheckListMenu,
    file: _updateFile,
    //date: _updateCalenderMenu,
    //time: _updateClockMenu
  };

  /**
   * Sets an event listener for the given element (element) which listens at the given port (listener).
   * Triggers either a parameter update or a settings update, depending on the options of the controls initialization.
   *
   * The menuEl.valueConversion can either be:
   *  - the name of the property that should be used,
   *  - a callback which returns the value (input to that callback is the menu element and the element itself) or
   *  - an object with:
   *    - the 'update' property as a string, the property that is chosen is solely used to update the value of the elements in the menu
   *    - the 'f' property as a function that returns the value for further processing
   *    - an optional 'i' property as a function that returns the value for updating the control based on an external change of the setting's or parameter's value
   *
   * A timeout can be defined to make delayed updates possible
   *
   * @param {String} id Either the id of the parameter or the name of the setting
   * @param {Object} menuEl The whole element
   * @param {element} obj The specific element (child or sub-child of menuEl) to which to assign the listener
   * @param {String} listener The value to listen to
   * @param {Function} update The function to call to update the menu elements
   * @param {Number} [timeoutInterval] An optional number that delays the update and resets it if another event occured
   * @return {Function} the event handler function which was registered
   */
  function _setEventListener(id, menuEl, element, listener, update, timeoutInterval) {
    let timeout,
        interval = timeoutInterval || 0,
        val1, val2,
        handler;

    // listen for an event to occur
    handler = function () {

      if(!API)
        _destroy();

      // get the value
      if (menuEl.valueConversion.update && menuEl.valueConversion.f) {
        val1 = element[menuEl.valueConversion.update];
        val2 = menuEl.valueConversion.f(menuEl, element);
      } else {
        if (typeof menuEl.valueConversion === 'string') {
          val1 = val2 = element[menuEl.valueConversion];
        } else {
          val1 = val2 = menuEl.valueConversion(menuEl, element);
        }
      }

      // update the menu element, check if update got accepted
      if( !update(menuEl, val1) ) {
        return;
      }

      // clear the timeout if there was one
      clearTimeout(timeout);

      // set a new timeout (with 0 if no interval was defined) and update parameter/setting when done
      timeout = setTimeout(function () {
        if (menuEl.parameter === true) {
          API.parameters.updateAsync({ id: id, value: val2 });
        } else if (menuEl.export === true) {
          API.exports.requestAsync({ id: id });
        } else {
          API.updateSettingAsync(id, val2);
        }
      }, interval);
    };

    element[listener] = handler;
    return handler;
  }

  /**
   * Destroys the controls with all its components.
   */
  function _destroy() {
    while (CONTAINER.firstChild)
      CONTAINER.removeChild(CONTAINER.firstChild);
    _paramIds.length = 0;
    _menuElements.length = 0;
    _plugins.length = 0;
  }

  function _save() {
    if(options && options.editMode === true){
      // console.log('Parameters before saving', API.parameters.get()); // FIXME comment this
      // console.log('Exports before saving', API.exports.get()); // FIXME comment this
      for(let i = 0, len = _menuElements.length; i < len; i++){
        let el = _menuElements[i];

        let updateObject = {
          id: el.id
        };

        let name = el.type === TYPES.BUTTON || el.type === TYPES.FILE ? el.button.innerHTML.replace('<span>', '').replace('</span>', '') : el.label.innerHTML;
        if(el.name !== name)
          updateObject.name = name;

        if(el.hidden !== el.row.classList.contains('sdv-hidden'))
          updateObject.hidden = el.row.classList.contains('sdv-hidden');

        if(el.order !== i)
          updateObject.order = i;

        if(Object.keys(updateObject).length > 1){
          if(el.parameter === true) {
            API.parameters.updateProperties(updateObject);
          } else if (el.export === true) {
            API.exports.updateProperties(updateObject);
          }
          // console.log(updateObject); // FIXME comment this
        }
        el.name = el.label.innerHTML;
        el.hidden = el.row.classList.contains('sdv-hidden');
        el.order = i;
      }
      // console.log('Parameters after saving', API.parameters.get()); // FIXME comment this
      // console.log('Exports after saving', API.exports.get()); // FIXME comment this
    }
  }

  function _initEditMode() {
    let editIcon = _createDOMElement('i', { classList: ['fa', 'fa-pencil-square-o', 'sdv-control-panel-icon', 'sdv-control-panel-edit-toggle-icon'] });
    _acc.appendChild(editIcon);
    /* eslint-disable */
    //$(_acc).after(editIcon);
    /* eslint-enable */

    editIcon.onclick = function() {
      if (editIcon.classList.contains('fa-check')) {
        editIcon.classList.remove('fa-check');
        editIcon.classList.add('fa-pencil-square-o');
        for(let i = 0, len = _menuElements.length; i < len; i++) {
          let el = _menuElements[i];
          el.label.contentEditable = false;
        }
      }
      else {
        editIcon.classList.remove('fa-pencil-square-o');
        editIcon.classList.add('fa-check');
        for(let i = 0, len = _menuElements.length; i < len; i++) {
          let el = _menuElements[i];
          el.label.contentEditable = true;
        }

      }
    };

    /* eslint-disable */
    Sortable.create(_container, {
      handle: '.fa-bars',
      onEnd: function (evt) {
        let oldI = evt.oldIndex,
            newI = evt.newIndex;

        if (oldI != null && newI != null && oldI != newI)
          _menuElements.splice(newI, 0, _menuElements.splice(oldI, 1)[0]);
      }});
    /* eslint-enable */
  }

  function _updateElements() {
    let i, len;
    for(i = 0, len = _menuElements.length; i < len; i++) {
      if(_menuElements[i].row.parentNode === _container)
        _container.removeChild(_menuElements[i].row);
    }

    _menuElements.sort(function(a, b) {
      return a.order - b.order;
    });

    for(i = 0, len = _menuElements.length; i < len; i++) {
      if((options && options.editMode) || !_menuElements[i].hidden)
        _container.appendChild(_menuElements[i].row);
    }
  }

  function _registerMenuElement(event, t) {
    if(!event[t]) return;
    let id = Object.keys(event[t])[0],
        param = event[t][id],
        type;

    if(!_paramIds.includes(id)) {
      // create
      type = TYPE_CONVERSION[t + '.' + param.type + '.' + param.visualization];
      if (!type) type = TYPE_CONVERSION[t + '.' + param.type];
      if (!type) type = TYPE_CONVERSION[t];
      if (!type) return;
      param.menuElementType = type;

      param.hidden = param.hidden === undefined ? false : param.hidden;
      param.order = param.order === undefined ? Number.MAX_SAFE_INTEGER : param.order;

      let el = new MenuElement(param.menuElementType, param);
      el[t] = true;
      _menuElements.push(el);
      _paramIds.push(id);


      if(options && options.editMode) {
        el.hideIcon = _createDOMElement('i', { id: el.slugId + '-hide-icon',
                                               classList: ['fa', 'fa-eye-slash', 'sdv-control-panel-icon'] });

        el.sortIcon = _createDOMElement('i', { id: el.slugId + '-sort-icon',
                                               classList: ['fa', 'fa-bars', 'sdv-control-panel-icon'] });

        el.hideIcon.onclick = function () {
          if (el.row.classList.contains('sdv-hidden')) {
            el.row.classList.remove('sdv-hidden');
            if(el.type === TYPES.COLOR)
              el.colorPicker.classList.remove('sdv-hidden');
            if(el.type === TYPES.BOOLEAN)
              el.container.classList.remove('sdv-hidden');
          } else {
            el.row.classList.add('sdv-hidden');
            if(el.type === TYPES.COLOR)
              el.colorPicker.classList.add('sdv-hidden');
            if(el.type === TYPES.BOOLEAN)
              el.container.classList.add('sdv-hidden');
          }
        };

        if (el.hidden){
          el.row.classList.add('sdv-hidden');
          if(el.type === TYPES.COLOR)
            el.colorPicker.classList.add('sdv-hidden');
          if(el.type === TYPES.BOOLEAN)
            el.container.classList.add('sdv-hidden');
        }

        // TODO Alex, depending on implementation, the EXPORT type might be the first case, too
        if (el.type === TYPES.BUTTON) {
          el.row.insertBefore(el.hideIcon, el.row.childNodes[0]);
          el.row.insertBefore(el.sortIcon, el.row.childNodes[1]);
          el.hideIcon.classList.add('fa-eye-slash-full-row');
        } else {
          el.row.insertBefore(el.hideIcon, el.row.childNodes[1]);
          el.row.insertBefore(el.sortIcon, el.row.childNodes[2]);
        }
        CONTAINER.classList.add('sdv-control-panel-edit-mode');
      }

      _updateElements();

    } else {
      _updateMenuElement(event, t);
    }
  }

  function _updateMenuElement(event, t) {
    if (!event[t]) return;
    let id = Object.keys(event[t])[0],
        param = event[t][id],
        i, len, el;

    if (_paramIds.includes(id)) {
      // update
      for (i = 0, len = _menuElements.length; i < len; i++) {
        el = _menuElements[i];
        if (el.id === id) {
          if (param.hidden !== undefined) {
            el.hidden = param.hidden;
            if (param.hidden) {
              el.row.classList.add('sdv-hidden');
              if(el.type === TYPES.COLOR)
                el.colorPicker.classList.add('sdv-hidden');
              if(el.type === TYPES.BOOLEAN)
                el.container.classList.add('sdv-hidden');
            } else {
              el.row.classList.remove('sdv-hidden');
              if(el.type === TYPES.COLOR)
                el.colorPicker.classList.remove('sdv-hidden');
              if(el.type === TYPES.BOOLEAN)
                el.container.classList.remove('sdv-hidden');
            }
          }
          if (param.order !== undefined) el.order = param.order;
          if (param.name !== undefined) {
            if (el.name !== param.name) {
              el.name = param.name;
              if (el.type === TYPES.BUTTON || el.type === TYPES.FILE) {
                el.button.innerHTML = '<span>' + el.name + '</span>';
              } else {
                el.label.innerHTML = el.name;
              }
            }
          }
          break;
        }
      }
      _updateElements();

    } else {
      _registerMenuElement(event, t);
    }
  }

  function _updateMenuElementValue(event) {
    let plugin, paras, el, id, i, j, lenI, lenJ;
    if (event.parameter) {
      for (i = 0, lenI = _plugins.length; i < lenI; i++) {
        plugin = _plugins[i];
        paras = event.parameter[plugin];
        if (paras) {
          for (id in paras) {
            for (j = 0, lenJ = _menuElements.length; j < lenJ; j++) {
              el = _menuElements[j];
              if (el.plugin === plugin && el.id === id)
                el.update(el, paras[id]);
            }
          }
        }
      }
    }
  }

  /**
   *
   *
   * CREATION OF ALL MENU ELEMENTS
   *
   *
   */
  {
    let s, setting;

    _runtimeId = API.getRuntimeId();
    _container = document.createElement('div');
    _container.classList.add(STRING_SDVCP + 'row-container');

    // creation of the settings controls
    if (options && options.settings) {

      // update the settings when an event was triggered
      API.addEventListener('settings.update', function (event) {
        if(event.settings){
          let i, len, el,
              key = event.settings.key,
              value = event.settings.valueNew;

          for(i = 0, len = _menuElements.length; i < len; i++){
            el = _menuElements[i];
            if(el.setting === key){
              if(el.valueConversion && el.valueConversion.i){
                el.update(el, el.valueConversion.i(el, value));
              } else {
                el.update(el, value);
              }
            }
          }
        }
      });

      // create the initial div
      _acc = _createDOMElement('button', { id: _runtimeId + '_' + STRING_SDCP + 'main-accordion-settings', parent: CONTAINER,
                                           classList: STRING_SDCP + 'accordion' });
      _createDOMElement('div', { id: _runtimeId + '_' + 'settings-text', parent: _acc, innerHTML: 'VIEWER SETTINGS', classList: ['shapediver-viewer-element', 'sd-control-panel-accordion-text']} );
      CONTAINER.appendChild(_container);

      if(api.addEventListener)
        api.addEventListener(api.EVENTTYPE.DESTROYED, function(event){
          if(event.type === 'destroyed')
            _destroy();
        });
      // create a new element for every setting in the list
      for (s of Object.keys(SETTINGS_LIST)) {
        setting = SETTINGS_LIST[s];
        if(api.getSetting(setting.setting) !== undefined)
          _menuElements.push(new MenuElement(setting.type, setting));
      }
    }
    // creation of the parameter controls
    else {
      _acc = _createDOMElement('button', { id: _runtimeId + '_' + STRING_SDCP + 'main-accordion-parameters', parent: CONTAINER,
                                           classList: STRING_SDCP + 'accordion' });
      let text = _createDOMElement('div', { id: _runtimeId + '_' + 'settings-text', parent: _acc, innerHTML: 'MODEL PARAMETERS', classList: ['shapediver-viewer-element', 'sd-control-panel-accordion-text']} );
      CONTAINER.appendChild(_container);

      if(options && options.editMode)
        text.style.width = '80%';

      if(options && options.editMode)
        _initEditMode();

      API.parameters.addEventListener(API.parameters.EVENTTYPE.REGISTERED, function(event) {
        _registerMenuElement(event, 'parameter');
      });

      API.parameters.addEventListener(API.parameters.EVENTTYPE.UPDATE, function(event) {
        _updateMenuElement(event, 'parameter');
      });

      API.parameters.addEventListener(API.parameters.EVENTTYPE.VALUE_UPDATE, _updateMenuElementValue);


      API.exports.addEventListener(API.exports.EVENTTYPE.REGISTERED, function(event) {
        _registerMenuElement(event, 'export');
      });

      API.exports.addEventListener(API.exports.EVENTTYPE.UPDATE, function(event) {
        _updateMenuElement(event, 'export');
      });

      API.exports.addEventListener(API.exports.EVENTTYPE.VALUE_UPDATE, _updateMenuElementValue);

    }

  }

  /**
   *
   *
   * SPECIFIC CREATION
   *
   *
   */

  /**
   * Creates the slider menu element.
   *
   * @param {Object} menuEl The complete menu element
   * @param {String} id The id of the parameter or name of the setting
   * @param {Object} param The parameters of the paramter/setting. For this type that must include:
   *  - defval: a default value
   *  - valueConversion: an optional string, array or function which determines the conversion of the event listener (see _setEventListener)
   *  - min: a minimum value
   *  - max: a maximum value
   *  - decimalplaces: the number of decimal places (optional, default 0)
   *  - type: the type, options: 'Even', 'Odd', 'Int', 'Float'
   */
  function _createSlider(menuEl, id, param) {
    let minVal = param.min,
        maxVal = param.max,
        defaultVal = param.defval,
        // the step value determines the interval in which values are chosen
        step = param.decimalplaces == null ? 0 :
          param.type == 'Even' || param.type == 'Odd' ? 2 :
            param.type == 'Int' || param.type == 'Odd' || param.type == 'Even' ? 1 : Math.pow(0.1, param.decimalplaces);

    // create the range dom element
    menuEl.cInputRange = _createDOMElement('input', { id: menuEl.slugId + '-range', parent: menuEl.row, value: defaultVal,
                                                      classList: [STRING_SDVCP + 'slider-input-range', STRING_SDVCPC],
                                                      attributes: { 'type': 'range', 'name': menuEl.slugId + '-range', 'min': minVal, 'max': maxVal, 'step': step } });

    // create the number input field dom element
    menuEl.cInputNumber = _createDOMElement('input', { id: menuEl.slugId + '-number', parent: menuEl.row, value: defaultVal,
                                                       classList: [STRING_SDVCP + 'slider-input-number', STRING_SDVCPC],
                                                       attributes: { 'type': 'number', 'name': menuEl.slugId + '-number', 'min': minVal, 'max': maxVal, 'step': step } });

    // set the event listeners
    menuEl.valueConversion = param.valueConversion ? param.valueConversion : 'value';
    _setEventListener(id, menuEl, menuEl.cInputRange, 'onchange', _updateSlider);
    _setEventListener(id, menuEl, menuEl.cInputNumber, 'onchange', _updateSlider);

    // when the range is updated, display the change in the input field
    menuEl.cInputRange.oninput = function () {
      menuEl.cInputNumber.value = menuEl.cInputRange.value;
    };
  }

  /**
   * Update the menu elements.
   *
   * @param {Object} menuEl The current menu element
   * @param {String} value The new value
   */
  function _updateSlider(menuEl, value) {
    menuEl.cInputRange.value = value;
    menuEl.cInputNumber.value = value;
    return true;
  }

  /**
   * Creates the string input menu element.
   *
   * @param {Object} menuEl The complete menu element
   * @param {String} id The id of the parameter or name of the setting
   * @param {Object} param The parameters of the paramter/setting. For this type that must include:
   *  - defval: a default value
   *  - valueConversion: an optional string, array or function which determines the conversion of the event listener (see _setEventListener)
   *  - max: a maximum number of characters
   */
  function _createStringInput(menuEl, id, param) {
    let defaultVal = param.defval,
        maxLength = parseInt(param.max);

    // create the string input dom element
    menuEl.cInputText = _createDOMElement('input', { id: menuEl.slugId + '-text', parent: menuEl.row, maxLength: maxLength, value: defaultVal,
                                                     classList: [STRING_SDVCP + 'string-input-text', STRING_SDVCPC],
                                                     attributes: { 'type': 'text', 'name': menuEl.slugId + '-text' } } );

    // set the event listeners
    menuEl.valueConversion = param.valueConversion ? param.valueConversion : 'value';
    _setEventListener(id, menuEl, menuEl.cInputText, 'oninput', _updateStringInput, 1000);
  }

  /**
   * Update the menu elements.
   *
   * @param {Object} menuEl The current menu element
   * @param {String} value The new value
   */
  function _updateStringInput(menuEl, value) {
    menuEl.cInputText.value = value;
    return true;
  }

  /**
   * Creates the boolean input menu element.
   *
   * @param {Object} menuEl The complete menu element
   * @param {String} id The id of the parameter or name of the setting
   * @param {Object} param The parameters of the paramter/setting. For this type that must include:
   *  - defval: a default value
   *  - valueConversion: an optional string, array or function which determines the conversion of the event listener (see _setEventListener)
   *  - strue: a string describing the true value
   *  - sfalse: a string describing the true value
   */
  function _createBooleanInput(menuEl, id, param) {
    let strue = param.strue == undefined ? null : param.strue,
        sfalse = param.sfalse == undefined ? null : param.sfalse,
        defaultVal = param.defval == true;

    if (strue == null) {
      // create the pseudo label dom element
      menuEl.container = _createDOMElement('label', { id: menuEl.slugId + '_-checkbox-label', parent: menuEl.row, classList: STRING_SDVCPC,
                                                      className: STRING_SDVCP + 'boolean-input-checkbox-label control-checkbox',
                                                      attributes: { 'for': menuEl.slugId + '-checkbox' } } );

      // create the inout checkbox dom element
      menuEl.cInputCheckbox = _createDOMElement('input', { id: menuEl.slugId + '-checkbox', parent: menuEl.container, checked: defaultVal,
                                                           classList: [STRING_SDVCP + 'boolean-input-checkbox', STRING_SDVCPC],
                                                           attributes: { 'type': 'checkbox', 'name': menuEl.slugId + '-checkbox' } } );

      // create the checkbox helper dom element
      _createDOMElement('div', { id: menuEl.slugId + '-checkbox-helper', parent: menuEl.container,
                                 classList: STRING_SDVCP + 'boolean-input-boxhelper',
                                 attributes: { 'for': menuEl.slugId + '-checkbox' } } );

      // set the event listeners
      menuEl.valueConversion = param.valueConversion ? param.valueConversion : 'checked';
      _setEventListener(id, menuEl, menuEl.cInputCheckbox, 'onchange', _updateBooleanInput);
    }
    else {

      // create the form dom element
      menuEl.container = _createDOMElement('form', { id: menuEl.slugId + '-form', parent: menuEl.row,
                                                     classList: [STRING_SDVCP + 'boolean-input-form', STRING_SDVCPC] });
      menuEl.label.setAttribute('for', menuEl.slugId + '-form');

      // create the true label dom element
      _createDOMElement('label', { id: menuEl.slugId + '-label-true', parent: menuEl.container, innerHTML: strue,
                                   classList: STRING_SDVCP + 'boolean-input-radio-label' } );

      // create the true radio button dom element
      menuEl.cInputCheckboxTrue = _createDOMElement('input', { id: menuEl.slugId + '-radio-true', parent: menuEl.container, innerHTML: strue, checked: defaultVal, value: 'true',
                                                               classList: STRING_SDVCP + 'boolean-input-radio',
                                                               attributes: { 'type': 'radio', 'name': menuEl.slugId + '-radio-true' } } );

      // create the false label dom element
      _createDOMElement('label', { id: menuEl.slugId + '-label-false', parent: menuEl.container, innerHTML: sfalse,
                                   classList: STRING_SDVCP + 'boolean-input-radio-label'} );

      // create the false radio button dom element
      menuEl.cInputCheckboxFalse = _createDOMElement('input', { id: menuEl.slugId + '-radio-false', parent: menuEl.container, innerHTML: sfalse, checked: !defaultVal, value: 'true',
                                                                classList: STRING_SDVCP + 'boolean-input-radio',
                                                                attributes: { 'type': 'radio', 'name': menuEl.slugId + '-radio-false' } } );

      // set the event listeners
      menuEl.valueConversion = param.valueConversion ? param.valueConversion : 'checked';
      _setEventListener(id, menuEl, menuEl.cInputCheckboxTrue, 'onchange', _updateBooleanInput);

      // when the false checkbox is ticked, call the other ones change event
      menuEl.cInputCheckboxFalse.onchange = function () {
        menuEl.cInputCheckboxTrue.checked = !menuEl.cInputCheckboxFalse.checked;
        if (menuEl.cInputCheckboxFalse.checked)
          menuEl.cInputCheckboxTrue.onchange(true);
      };

      // create a break dom element (no idea why though :D)
      menuEl.container.appendChild(_createDOMElement('br'));
    }
  }

  /**
   * Update the menu elements.
   *
   * @param {Object} menuEl The current menu element
   * @param {String} value The new value
   */
  function _updateBooleanInput(menuEl, value) {
    if (menuEl.cInputCheckbox) menuEl.cInputCheckbox.checked = value;
    if (menuEl.cInputCheckboxTrue) menuEl.cInputCheckboxTrue.checked = value;
    if (menuEl.cInputCheckboxFalse) menuEl.cInputCheckboxFalse.checked = !value;
    return true;
  }

  /**
   * Creates the string input menu element.
   *
   * @param {Object} menuEl The complete menu element
   * @param {String} id The id of the parameter or name of the setting
   * @param {Object} param The parameters of the paramter/setting. For this type that must include:
   *  - defval: a default value
   *  - valueConversion: an optional string, array or function which determines the conversion of the event listener (see _setEventListener)
   *  - max: a maximum number of characters
   */
  function _createColorInput(menuEl, id, param) {
    let defaultVal = param.defval,
        // test if the type color is supported
        /* eslint-disable */
        colorInput = $('<input type="color" value="!" />')[0];
        /* eslint-enable */

    // create the color input dom element
    menuEl.cInputColor = _createDOMElement('input', { id: menuEl.slugId + '-color', parent: menuEl.row,
                                                      classList: [STRING_SDVCP + 'color-input-color', STRING_SDVCPC],
                                                      attributes: { 'name': menuEl.slugId + '-color' } } );

    // convert the color to a tiny color
    defaultVal = TO_TINY_COLOR(defaultVal);

    // if color supported and a mobile device, use the device color picker
    if ((colorInput.type === 'color' && colorInput.value !== '!') && _isMobile) {
      menuEl.cInputColor.setAttribute('type', 'color');
      menuEl.cInputColor.value = defaultVal.toHexString();
      menuEl.colorPicker = menuEl.cInputColor;
    }
    // otherwise use the spectrum color picker
    else {
      menuEl.cInputColor.setAttribute('type', 'text');
      /* eslint-disable */
      $('#' + menuEl.slugId + '-color').spectrum({
        color: defaultVal.toRgbString(),
        showAlpha: true,
        showInput: true,
        showInitial: true,
        preferredFormat: 'rgb'
      });
      /* eslint-enable */
      menuEl.colorPicker = menuEl.row.getElementsByClassName('sp-replacer')[0];
    }

    // set the event listeners
    menuEl.valueConversion = param.valueConversion ? param.valueConversion : 'value';
    _setEventListener(id, menuEl, menuEl.cInputColor, 'onchange', _updateColorInput);
  }

  /**
   * Update the menu elements.
   *
   * @param {Object} menuEl The current menu element
   * @param {String} value The new value
   */
  function _updateColorInput(menuEl, value) {
    let color = TO_TINY_COLOR(value);
    // we are using either a native color input, or the spectrum color picker
    if (menuEl.cInputColor.type === 'color') {
      menuEl.cInputColor.value = color.toHexString();
    } else {
      $('#' + menuEl.slugId + '-color').spectrum('set', color.toRgbString());
    }
    return true;
  }

  /**
   * Creates the button menu element.
   *
   * @param {Object} menuEl The complete menu element
   * @param {String} id The id of the parameter or name of the setting
   * @param {Object} param The parameters of the paramter/setting. For this type that must include:
   *  - valueConversion: an optional string, array or function which determines the conversion of the event listener (see _setEventListener)
   *  - name: the name of the button
   */
  function _createButton(menuEl, id, param) {
    let title = param.name;

    menuEl.row.removeChild(menuEl.label);

    // create the button dom element
    menuEl.button = _createDOMElement('button', { id: menuEl.slugId + '_button', parent: menuEl.row, innerHTML: '<span>' + title + '</span>',
                                                  classList: ['sdv-control-button', STRING_SDVCPC],
                                                  attributes: { 'type': 'button', 'name': menuEl.slugId + '_button' } } );

    // set the event listeners
    menuEl.valueConversion = param.valueConversion ? param.valueConversion : 'none';
    _setEventListener(id, menuEl, menuEl.button, 'onclick', _updateButton);
  }

  /**
   * Update the menu elements.
   *
   * @param {Object} menuEl The current menu element
   * @param {String} value The new value
   */
  function _updateButton(menuEl, value) {
    // nothing to update when the button is pressed
    return true;
  }

  /**
   * Creates the file menu element.
   *
   * @param {Object} menuEl The complete menu element
   * @param {String} id The id of the parameter or name of the setting
   * @param {Object} param The parameters of the paramter/setting. For this type that must include:
   *  - valueConversion: an optional string, array or function which determines the conversion of the event listener (see _setEventListener)
   *  - name: the name of the export
   */
  function _createFile(menuEl, id, param) {
    let title = param.name,
        drag_handler_dummy,
        drop_handler,
        files_dropped = null;

    // Change the label to show 'Select file', or the selected file name
    //menuEl.row.removeChild(menuEl.label);
    menuEl.label.innerHTML = 'Select file…';

    // create the button dom element
    menuEl.button = _createDOMElement('button', { id: menuEl.slugId + '_button', parent: menuEl.row, innerHTML: '<span>' + title + '</span>',
                                                  classList: ['sdv-control-button', STRING_SDVCPC],
                                                  attributes: { 'type': 'button', 'name': menuEl.slugId + '_button' } } );

    // create the hidden file input dom element (we don't want to see the ugly file input button)
    menuEl.fileinput = _createDOMElement('input', { id: menuEl.slugId + '_fileinput', parent: menuEl.row, style: 'display:none',
                                                    accept: param.format.join(','),
                                                    attributes: { 'type': 'file', 'name': menuEl.slugId + '_fileinput' } } );
    menuEl.fileinput.style.display = 'none';

    // trigger fileinput click from clicks on the button
    menuEl.button.addEventListener('click', function() {menuEl.fileinput.click();});

    // callback for event listener, to get the current value, we return the select File object or an empty string
    menuEl.valueConversion = function(menuEl, fileinput) {
      if (files_dropped && files_dropped.length > 0) {
        let file = files_dropped[0];
        files_dropped = null;
        return file;
      } else if (fileinput.files.length > 0) {
        return fileinput.files[0];
      } else {
        return '';
      }
    };

    // helper for checking format
    menuEl.checkMimeType = function(type) {
      return param.format.includes(type);
    };

    // helper for getting parameter definition
    menuEl.getParamDef = function() {
      return param;
    };

    // helper for checking maximum blob size
    menuEl.checkSize = function(size) {
      return size <= param.max;
    };

    // helper for clearing selected file
    menuEl.clear = function() {
      files_dropped = null;
      if (menuEl.fileinput.files.length > 0) {
        menuEl.fileinput.value = null;
      } else {
        menuEl.change_handler();
      }
    };

    // set the event listeners
    menuEl.change_handler = _setEventListener(id, menuEl, menuEl.fileinput, 'onchange', _updateFile);

    // drag event handling
    drag_handler_dummy = function(e) {
      e.stopPropagation();
      e.preventDefault();
    };
    menuEl.button.addEventListener('dragenter', drag_handler_dummy, false);
    menuEl.button.addEventListener('dragover', drag_handler_dummy, false);

    drop_handler = function(e) {
      e.stopPropagation();
      e.preventDefault();
      if (e.dataTransfer) {
        files_dropped = e.dataTransfer.files;
      }
      menuEl.change_handler();
    };
    menuEl.button.addEventListener('drop', drop_handler, false);
  }

  /**
   * Update the menu elements.
   *
   * @param {Object} menuEl The current menu element
   * @param {String} value The new value
   */
  function _updateFile(menuEl, value) {
    if ( value instanceof File ) {
      // get the format, if there is none guess it from the name
      if ( value.type.length > 0 ) {
        value._type = value.type;
      } else {
        value._type = GLOBAL_UTILS.guessMimeTypeFromFilename(value.name);
      }
      // deny update if the format is not allowed
      if ( !menuEl.checkMimeType(value._type) ) {
        SHOW_MESSAGE('warning', 'Allowed file types: ' + menuEl.getParamDef().format.join(', '));
        return false;
      }
      // deny update if the file size is exceeded
      if ( !menuEl.checkSize(value.size) ) {
        SHOW_MESSAGE('warning', 'Maximum file size: ' + menuEl.getParamDef().max + ' bytes');
        return false;
      }
      // show the filename
      menuEl.label.innerHTML = value.name;
    } else if (typeof value === 'string' && value.length > 0) {
      // ignore file id, instead attach an icon to the label which already shows the filename
      menuEl.label.innerHTML += ' \u274C';
      // make label clickable to remove selected file
      menuEl.label.onclick = function() {
        menuEl.clear();
      };
    } else {
      menuEl.label.innerHTML = 'Select file…';
      menuEl.label.onclick = null;
    }
    return true;
  }

  /**
   * Creates the dropdown menu element.
   *
   * @param {Object} menuEl The complete menu element
   * @param {String} id The id of the parameter or name of the setting
   * @param {Object} param The parameters of the paramter/setting. For this type that must include:
   *  - defval: a default value
   *  - valueConversion: an optional string, array or function which determines the conversion of the event listener (see _setEventListener)
   *  - choices: a string array of choices
   */
  function _createDropdownMenu(menuEl, id, param) {
    let choices = param.choices,
        defaultVal = param.defval,
        i;

    // create the selection dom element
    menuEl.cSelect = _createDOMElement('select', { id: menuEl.slugId + '-form', parent: menuEl.row,
                                                   classList: [STRING_SDVCP + 'dropdown-input-select', STRING_SDVCPC] } );

    menuEl.choices = choices.length;
    // add all choices
    for (i = 0; i < choices.length; i++) {
      // create the option dom element
      menuEl['cOption' + i] = _createDOMElement('option', { id: menuEl.slugId + '-option-' + i, parent: menuEl.cSelect, innerHTML: choices[i], value: i,
                                                            classList: STRING_SDVCP + 'dropdown-input-option',
                                                            attributes: { 'name': menuEl.slugId + '-option-' + i } } );
      if (i === defaultVal)
        menuEl['cOption' + i].selected = true;
    }

    // set the event listeners
    menuEl.valueConversion = param.valueConversion ? param.valueConversion : 'selectedIndex';
    _setEventListener(id, menuEl, menuEl.cSelect, 'onchange', _updateDropdownMenu);
  }

  /**
   * Update the menu elements.
   *
   * @param {Object} menuEl The current menu element
   * @param {String} value The new value
   */
  function _updateDropdownMenu(menuEl, value) {
    menuEl.cSelect.value = value;
    for (let i = 0; i < menuEl.choices; i++) {
      if (i === value) {
        menuEl['cOption' + i].selected = true;
      } else {
        menuEl['cOption' + i].selected = false;
      }
    }
    return true;
  }

  /**
   * Creates the check list menu element.
   *
   * @param {Object} menuEl The complete menu element
   * @param {String} id The id of the parameter or name of the setting
   * @param {Object} param The parameters of the paramter/setting. For this type that must include:
   *  - defval: a default value, in this case a array of the indices of the checked boxes
   *  - valueConversion: an optional string, array or function which determines the conversion of the event listener (see _setEventListener)
   *  - choices: a string array of choices
   */
  function _createCheckListMenu(menuEl, id, param) {
    let choices = param.choices,
        defaultVal = param.defval,
        cForm, listContainer, rLabel, cInputCheckbox, i, j, len;

    // create the form dom element
    cForm = _createDOMElement('form', { id: menuEl.slugId + '-form', parent: menuEl.row,
                                        classList: [STRING_SDVCP + 'dropdown-input-form', STRING_SDVCPC] } );

    menuEl.cInputArr = [];
    // add all choices
    for (i = 0, len = choices.length; i < len; ++i) {

      // create the div dom element for a choice
      listContainer = _createDOMElement('div', { parent: cForm });

      // create the label dom element for a choice
      rLabel = _createDOMElement('label', { id: menuEl.slugId + '-label-' + i, parent: listContainer, innerHTML: choices[i],
                                            classList: [STRING_SDVCP + 'checklist-input-checkbox-label', 'control-checkbox'] } );

      // create the checkbox dom element for a choice
      cInputCheckbox = _createDOMElement('input', { id: menuEl.slugId + '-checkbox-' + i, parent: rLabel, innerHTML: choices[i], value: i,
                                                    classList: STRING_SDVCP + 'checklist-input-checkbox',
                                                    attributes: { 'type': 'checkbox', 'name': menuEl.slugId + '-checkbox-' + i } } );

      // create the checkbox helper dom element for a choice
      _createDOMElement('div', { id: menuEl.slugId + '-checkbox-helper', parent: rLabel,
                                 classList: STRING_SDVCP + 'checklist-input-boxhelper',
                                 attributes: { 'for': menuEl.slugId + '-checkbox-' + i } } );

      // set to checked if it is in the default values
      cInputCheckbox.checked = defaultVal.includes(i);
      menuEl.cInputArr.push(cInputCheckbox);

      // a special value conversion is needed as the event listeners are set for the single options
      // therefore the conversion has to be made to create an array of all ticked boxes
      menuEl.valueConversion = param.valueConversion ? param.valueConversion :
        function (menuEl) {
          let curValArr = [];
          for (j = 0; j < menuEl.cInputArr.length; ++j) {
            if (menuEl.cInputArr[j].checked)
              curValArr.push(j);
          }
          return curValArr;
        };

      // set the event listeners
      _setEventListener(id, menuEl, cInputCheckbox, 'onchange', _updateCheckListMenu);
    }
  }

  /**
   * Update the menu elements.
   *
   * @param {Object} menuEl The current menu element
   * @param {String} value The new value
   */
  function _updateCheckListMenu(menuEl, value) {
    for (let i = 0, len1 = menuEl.cInputArr.length; i < len1; ++i) {
      menuEl.cInputArr[i].checked = value.includes(i);
    }
    return true;
  }

  //function _createCalenderMenu(menuEl, id, param) {}

  //function _updateCalenderMenu(menuEl, value) {}

  //function _createClockMenu(menuEl, id, param) {}

  //function _updateClockMenu(menuEl, value) {}

  return {
    destroy: _destroy,
    save: _save
  };
};

module.exports = SDControls;
